const FALL_EARLY_SPRING = 'fall/early spring';
const SPRING = 'spring';
const EARLY_SIDEDRESS = 'early_sidedress';
const LATE_SIDEDRESS = 'late_sidedress';
const INSTINCT = 'instinct';
const INSTINCT_NEXTGEN = 'instinct-nxtgen';
const N_SERVE = 'n-serve';
const CENTURO = 'centuro';
const GUARDIAN = 'guardian-l';
const FUNCTION = 'function';
const TRIDENT = 'trident';

export const nitrogenProtectant = {
  timings: [
    { id: FALL_EARLY_SPRING, label: 'Fall/Early Spring (pre-Mar 20)' },
    { id: SPRING, label: 'Spring' },
    { id: EARLY_SIDEDRESS, label: 'Early sidedress' },
    { id: LATE_SIDEDRESS, label: 'Late sidedress' },
  ],

  products: [
    { id: INSTINCT, label: 'Instinct', increments: [2, 3, 4, 5] },
    { id: INSTINCT_NEXTGEN, label: 'Instinct NXTGEN', increments: [2, 3, 4, 5] },
    { id: N_SERVE, label: 'N-Serve', increments: [2, 3, 4, 5] },
    { id: CENTURO, label: 'Centuro', increments: [2, 3, 4, 5] },
    { id: GUARDIAN, label: 'Guardian-L', increments: [2, 3, 4, 5] },
    { id: FUNCTION, label: 'Function', increments: [2, 3, 4, 5] },
    { id: TRIDENT, label: 'Trident', increments: [1, 2, 3, 4] },
  ],

  rates: {
    [N_SERVE]: {
      [FALL_EARLY_SPRING]: { baseRate: 32, minRate: 12, increment: 2 },
      [SPRING]: { baseRate: 32, minRate: 8, increment: 2 },
      [EARLY_SIDEDRESS]: { baseRate: 32, minRate: 8, increment: 2 },
      [LATE_SIDEDRESS]: { baseRate: 32, minRate: 8, increment: 2 },
    },
    [INSTINCT]: {
      [SPRING]: { baseRate: 37, minRate: 6, increment: 2 },
      [EARLY_SIDEDRESS]: { baseRate: 37, minRate: 6, increment: 2 },
      [LATE_SIDEDRESS]: { baseRate: 37, minRate: 6, increment: 2 },
    },
    [INSTINCT_NEXTGEN]: {
      [FALL_EARLY_SPRING]: { baseRate: 24, minRate: 12, increment: 2 },
      [SPRING]: { baseRate: 24, minRate: 6, increment: 2 },
      [EARLY_SIDEDRESS]: { baseRate: 24, minRate: 6, increment: 2 },
      [LATE_SIDEDRESS]: { baseRate: 24, minRate: 6, increment: 2 },
    },
    [CENTURO]: {
      [FALL_EARLY_SPRING]: { baseRate: 52, minRate: 25, increment: 2 },
      [SPRING]: { baseRate: 46, minRate: 16, increment: 2 },
      [EARLY_SIDEDRESS]: { baseRate: 39, minRate: 8, increment: 2 },
      [LATE_SIDEDRESS]: { baseRate: 36, minRate: 6, increment: 2 },
    },
    [FUNCTION]: {
      [FALL_EARLY_SPRING]: { baseRate: 32, minRate: 12, increment: 2 },
      [SPRING]: { baseRate: 32, minRate: 8, increment: 2 },
      [EARLY_SIDEDRESS]: { baseRate: 32, minRate: 8, increment: 2 },
      [LATE_SIDEDRESS]: { baseRate: 32, minRate: 8, increment: 2 },
    },
    [GUARDIAN]: {
      [FALL_EARLY_SPRING]: { baseRate: 70, minRate: 25, increment: 2 },
      [SPRING]: { baseRate: 60, minRate: 25, increment: 2 },
      [EARLY_SIDEDRESS]: { baseRate: 48, minRate: 20, increment: 2 },
      [LATE_SIDEDRESS]: { baseRate: 48, minRate: 16, increment: 2 },
    },
    [TRIDENT]: {
      [SPRING]: { baseRate: 9, minRate: 6, increment: 1 },
      [EARLY_SIDEDRESS]: { baseRate: 9, minRate: 5, increment: 1 },
      [LATE_SIDEDRESS]: { baseRate: 9, minRate: 5, increment: 1 },
    },
  },
};
